import { isValidPhoneNumber } from 'react-phone-number-input';
import { z } from 'zod';

import { INQUIRY_VALUES, PRODUCT_VALUES } from '../config/formOptions';

const requiredText = (label: string, min: number, max: number) =>
  z
    .string()
    .trim()
    .min(min, `${label} debe tener al menos ${min} caracteres.`)
    .max(max, `${label} no puede superar los ${max} caracteres.`);

export const quoteFormSchema = z.object({
  name: requiredText('El nombre', 2, 100),
  company: requiredText('La empresa', 2, 120),
  email: z
    .string()
    .trim()
    .min(1, 'Ingresá tu email.')
    .max(254, 'El email es demasiado largo.')
    .email('Ingresá un email válido.'),
  phone: z
    .string()
    .min(1, 'Ingresá tu teléfono.')
    .refine(isValidPhoneNumber, 'Ingresá un teléfono válido.'),
  inquiryType: z.enum(INQUIRY_VALUES, {
    error: 'Seleccioná un tipo de consulta.',
  }),
  productType: z.enum(PRODUCT_VALUES, {
    error: 'Seleccioná un tipo de producto.',
  }),
  quantity: z
    .string()
    .trim()
    .min(1, 'Ingresá una cantidad estimada.')
    .regex(/^\d+$/, 'La cantidad debe ser un número entero.')
    .transform(Number)
    .pipe(
      z
        .number()
        .int('La cantidad debe ser un número entero.')
        .min(1, 'La cantidad mínima es 1.')
        .max(999999, 'La cantidad máxima es 999999.'),
    ),
  comments: z
    .string()
    .trim()
    .max(1000, 'Los comentarios no pueden superar los 1000 caracteres.')
    .transform((value) => value || undefined),
  website: z.string().max(200).default(''),
  formStartedAt: z.string().datetime(),
});

export type QuoteFormInput = z.input<typeof quoteFormSchema>;
export type QuoteFormPayload = z.output<typeof quoteFormSchema>;

export const createDefaultValues = (): QuoteFormInput => ({
  name: '',
  company: '',
  email: '',
  phone: '',
  inquiryType: 'other',
  productType: 'other',
  quantity: '',
  comments: '',
  website: '',
  formStartedAt: new Date().toISOString(),
});
